import AutocompleteListbox from '@mui/joy/AutocompleteListbox';

import { withBaseSelectListBoxStyle } from '@components/BaseStyledComponents/BaseSelect';

export const BaseAutocompleteListbox: typeof AutocompleteListbox =
  withBaseSelectListBoxStyle(AutocompleteListbox);
